import { useEffect, useState } from "react";
import { SinisterAgreementService } from "../../../shared/services/api/sinister/SinisterAgreementService";

// GET /sinister-agreements/installments não expõe uma lista de clientes distintos (só filtra por
// clientName recebido) — ver nota do filtro "Cliente" em PR-10-controle-cobranca-listagem-parcelas-frontend.md.
// Por isso as opções do select seguem vindo de uma leva de GET /sinister-agreements (já existente,
// PR-04) buscada uma única vez, independente da paginação/filtro da listagem principal.
const CLIENT_OPTIONS_FETCH_LIMIT = 200;

export function useCollectionControlClientOptions() {
	const [clientNames, setClientNames] = useState<string[]>([]);

	useEffect(() => {
		let active = true;

		SinisterAgreementService.getAll(1, CLIENT_OPTIONS_FETCH_LIMIT).then((result) => {
			if (!active || result instanceof Error) return;

			const uniqueNames = Array.from(new Set(result.data.map((agreement) => agreement.client?.name).filter(Boolean))).sort() as string[];
			setClientNames(uniqueNames);
		});

		return () => {
			active = false;
		};
	}, []);

	return clientNames;
}
